<template>
  <ParentPage
    class="Reporting"
    :menu="menu"
    :root-route-name="rootRouteName"
  />
</template>

<script>
import { mapGetters } from 'vuex'

import { ReportingMenu } from '@/config'

import ParentPage from '@/components/ParentPage.vue'

import { fetchProcessesByType } from '@/services/processes'

export default {
  name: 'Config',
  components: {
    ParentPage,
  },
  data() {
    return {
      menu: ReportingMenu,
      rootRouteName: 'Reporting',
    }
  },
  computed: {
    ...mapGetters('user', ['canAccessReporting']),
    ...mapGetters('tenant', ['getActiveProcessTypes']),
  },
  async created() {
    // Access check
    if (!this.canAccessReporting) {
      this.$router.push({
        name: 'Dashboard',
      })
    }
    if (process.env.VUE_APP_TENANT === 'rvb'){
      this.$store.dispatch('processes/setCurrentProcessType', { processType: 'private' })
      const token = await this.$auth.getTokenSilently()
      await fetchProcessesByType({ token, processType: 'private' }).catch(err => console.log(err))
    }
  },
}
</script>
